import { SxProps } from "@mui/material";

export const sxIconButton: SxProps = {
    position: 'absolute',
    right: 13,
    top: 19,
    fontSize: '20px',
    color: '#383838',
}

export const sxModal: SxProps = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxHeight: '95vh',
    bgcolor: '#fff',
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0px 4px 100px 0px rgba(56, 56, 56, 0.20)',
    padding: '32px 48px',
    gap: '24px',
    overflow: 'auto'
}

export const sxTitleDefault: SxProps = {
    fontFamily: "UnimedSans-Bold",
    fontSize: "28px",
    color: "#383838",
}